module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_02.1f76eec6.jpg";